module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_library.js
// module id = 39
// module chunks = 0